import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import TestimonialsSection from "../components/TestimonialsSection";

export default function TestimonialsPage() {
  return (
    <>
      <SEO
        title="Traveller Reviews | D, Trio Trek"
        description="Reviews and stories from D Trio Trek travellers in Skardu and Baltistan."
        url="https://dtriotrek.com/testimonials"
      />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-primary-900 overflow-hidden">
        <div className="absolute -top-16 -right-16 w-80 h-80 bg-white/5 rounded-full" />
        <div className="absolute bottom-0 -left-20 w-64 h-64 bg-white/5 rounded-full" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block bg-white/20 text-white text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
            Traveler Reviews
          </span>
          <h1 className="font-display text-4xl md:text-6xl font-normal tracking-tight text-white mb-6 leading-[1.1]">
            Stories From
            <br />
            <span className="text-primary-200">Our Travellers</span>
          </h1>
          <p className="text-primary-100 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            What people say after travelling Baltistan with us — in their own
            words, published as they send them.
          </p>
        </div>
      </section>

      {/* All testimonials — or an honest word when there are none yet. */}
      <TestimonialsSection
        empty={
          <section className="py-20 px-4">
            <div className="max-w-xl mx-auto text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                No reviews published yet
              </h2>
              <p className="text-gray-600 mb-8">
                We would rather show you nothing than something we wrote
                ourselves. Travel with us and yours can be the first.
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link to="/tours" className="btn-primary">See the expedition</Link>
                <Link to="/contact" className="btn-outline">Talk to us</Link>
              </div>
            </div>
          </section>
        }
      />
    </>
  );
}
